package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import dev.lingvo.shared.StoreShotSetDto
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.i18n.t
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

/** CSP and provider read failures are visible rather than being mistaken for an empty store. */
@Composable
fun BeforeAfterStrip(before: StoreShotSetDto?, row: ReviewSetRow, urls: Map<String, String>) {
    var failed by remember(before) { mutableStateOf(false) }
    Div(attrs = { attr("data-before-after", ""); style { property("overflow-x", "auto"); property("max-width", "100%") } }) {
        Text(t("app.projects.slug.screenshots.before_after_strip.in_the_store", "In the store"))
        if (before == null || !before.readable || failed || before.images.any { it.previewUrl == null }) {
            LMuted(t("app.projects.slug.screenshots.before_after_strip.the_stores_current_images_couldnt_be", "The store's current images couldn't be shown"))
        } else before.images.forEach { image ->
            val url = image.previewUrl?.takeIf { it.startsWith("https://") }
            if (url == null) LMuted(t("app.projects.slug.screenshots.before_after_strip.the_stores_current_images_couldnt_be", "The store's current images couldn't be shown"))
            else Img(src = url, alt = "", attrs = {
                attr("referrerpolicy", "no-referrer"); attr("loading", "lazy")
                style { property("height", "96px"); property("width", "auto") }
                ref { imageElement ->
                    val listener = org.w3c.dom.events.EventListener { failed = true }
                    imageElement.addEventListener("error", listener)
                    onDispose { imageElement.removeEventListener("error", listener) }
                }
            })
        }
        Text(" → ")
        Text(t("app.projects.slug.screenshots.before_after_strip.will_be_sent", "Will be sent"))
        row.renders.forEach { render -> urls[render.id]?.let { url ->
            Img(src = url, alt = render.slotKey, attrs = { attr("lang", render.locale)
                style { property("height", "96px"); property("width", "auto") } })
        } }
    }
}
